import React from 'react';
import { convertTimestampToDateTime } from '../../../helper/helper';
import { BookModel } from '../../../interfaces/book.interface';
import { UserModel } from '../../../interfaces/user.interface';
import Button from '../../../components/Common/Button';
import BookCompleteBadge from '../../../components/BookCompleteBadge';
import { openPlanPurchaseModal } from '../../../store/appSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useStorageObjectUrl } from '../../../services/file.service';

interface BookCoverProps {
  book: BookModel;
  user: UserModel | null;
  isSelected?: boolean;
}

const BookCover: React.FC<BookCoverProps> = ({ book, user, isSelected }) => {
  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const storageObject = useStorageObjectUrl(book?.coverURL);
  const coverImage = book?.coverURL && storageObject ? storageObject.url : '/bookdraft.png';
  const backgroundSize = window.innerWidth < 640 ? '340px' : '317px';
  const backgroundPosition = window.innerWidth < 640 ? '29% 24%' : '46% 22%';

  const createNewStory = () => {
    // localStorage.setItem(UserLocalStorageKeysEnum.STORY_STEP, StoryStepsEnum.BASIC_INFO);
    // navigateTo('/');
    setTimeout(() => {
      dispatch(
        openPlanPurchaseModal({
          show: true,
          data: {
            title: 'Build Your Character!',
            description:
              "Order a physical copy of the book you're creating, or subscribe to a limited-time free trial to finish your current story and start new ones!",
          },
        }),
      );
    }, 0);
  };

  return (
    <div
      className={`annie w-[21.5rem] h-[21.5rem] px-1 object-cover mx-auto mb-2 flex justify-center items-center relative ${book?.isDemoBlocked ? 'block-image' : ''} rounded-lg ${isSelected ? 'border-4 border-storyblueSecondLightText' : 'border-4 border-transparent'}`}
    >
      {!book?.isDemoBlocked && (
        <BookCompleteBadge book={book} className="absolute top-2 left-2 z-20 shadow-md" />
      )}
      {book?.isDemoBlocked && (
        <div className="absolute w-full h-full rounded z-10">
          <div className="w-full h-full shadow-lg rounded-lg p-6 flex flex-col justify-center items-center cursor-default">
            <h2 className="text-3xl font-bold text-storyblueText font-caveat mt-4 mb-4 capitalize">
              Another Tale Awaits!
            </h2>
            <p className="text-base font-medium font-poppins text-storyblueText mt-5 mb-5 normal-case">
              Bring your imagination to life with a personalized adventure!
            </p>
            <Button
              title="Create New Story"
              onClick={() => createNewStory()}
              iconTemplate={<img src="/stars_Icon.svg" alt="" className={'ml-2 h-6 flex items-center'} />}
              className="bg-storySecondButton  hover:bg-storyerror flex justify-center items-center leading-none text-white font-sans font-bold rounded-xl p-2 pl-4 pr-4 text-base m-4 cursor-pointer"
            />
          </div>
        </div>
      )}
      <div
        className="absolute h-full w-full grayscale rounded shadow-xl"
        style={{
          backgroundImage: `url('${coverImage}')`,
          backgroundSize: 'cover',
        }}
      ></div>
      <div
        className="w-[16rem] h-[19rem] rounded-sm flex justify-center pt-[1rem]"
        style={{
          backgroundImage: `url('${'/texture.png'}')`,
          backgroundSize: 'cover',
          zIndex: 1,
        }}
      >
        <div
          className="custom-background w-[14rem] h-[14rem] flex justify-center items-center relative rounded-sm"
          style={{
            backgroundImage: `url('${coverImage}')`,
            backgroundSize: backgroundSize,
            backgroundPosition: backgroundPosition,
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="relative flex flex-col items-center top-[9.1rem]">
            <h1 className="text-[14px] leading-[21px]  flex justify-center items-center text-center font-yuji-boku text-storyblue">
              {book?.coverURL ? book?.title : null}
            </h1>
            <h1 className="font-poppins text-[10px] leading-[25px] text-gray-600  mb-1 capitalize">
              {book?.coverURL
                ? `by ${book?.authorName ? book?.authorName : user?.firstName + ' ' + user?.lastName}`
                : `Autosaved - ${convertTimestampToDateTime(book.timestamp!)}`}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookCover;
